<div class="table-wrapper">
  <ng-container *ngIf="isLoading && (!entries || entries.length === 0)">
    <div class="table-row-entry table-header">
      <div>{{ 'standings.club' | translate }}</div>
      <div></div>
      <div class="table-row-data">
        <span class="tablet-visible">{{ 'standings.matches' | translate }}</span>
        <span class="sm-mobile-visible">{{ 'standings.short.matches' | translate }}</span>
        <span class="desktop-visible">{{ 'standings.wins' | translate }}</span>
        <span class="desktop-visible">{{ 'standings.draws' | translate }}</span>
        <span class="desktop-visible">{{ 'standings.loses' | translate }}</span>
        <span class="tablet-visible">{{ 'standings.goals' | translate }}</span>
        <span class="sm-mobile-visible">{{ 'standings.short.goals' | translate }}</span>
        <span class="tablet-visible">{{ 'standings.points' | translate }}</span>
        <span class="sm-mobile-visible">{{ 'standings.short.points' | translate }}</span>
      </div>
    </div>
    <div class="table-skeleton">
      <div class="table-skeleton-row" *ngFor="let item of skeletonItems"></div>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoading || (entries && entries.length > 0)">
    <ng-container *ngIf="entries && entries.length > 0">
      <div class="table-row-entry table-header">
        <div>{{ 'standings.club' | translate }}</div>
        <div></div>
        <div class="table-row-data" [class.table-row-data--with-form]="hasFormData">
          <span class="tablet-visible">{{ 'standings.matches' | translate }}</span>
          <span class="sm-mobile-visible">{{
            'standings.short.matches' | translate
          }}</span>
          <span class="desktop-visible">{{ 'standings.wins' | translate }}</span>
          <span class="desktop-visible">{{ 'standings.draws' | translate }}</span>
          <span class="desktop-visible">{{ 'standings.loses' | translate }}</span>
          <span class="tablet-visible">{{ 'standings.goals' | translate }}</span>
          <span class="sm-mobile-visible">{{ 'standings.short.goals' | translate }}</span>
          <span class="tablet-visible">{{ 'standings.points' | translate }}</span>
          <span class="sm-mobile-visible">{{
            'standings.short.points' | translate
          }}</span>
          <span class="desktop-visible" *ngIf="hasFormData">{{
            'standings.form' | translate
          }}</span>
        </div>
      </div>
      <div>
        <tisa-season-table-entry
          (entryClicked)="onEntryClicked($event)"
          [liveMatchesTemplate]="liveMatchesTemplate"
          [entry]="entry"
          [hasFormData]="hasFormData"
          [isClickable]="!!onEntryClicked"
          *ngFor="let entry of entries"
        >
        </tisa-season-table-entry>
      </div>
    </ng-container>
  </ng-container>
</div>
